import { FlowFile } from '@appbase/libs/flowjs'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import flowHelper from '../flow-helper'
import api from '@appbase/api';

@Component
export default class FileListItem extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object, required: true }) file!: FlowFile
  @Prop({ type: String, default: '' }) beforeId!: string;
  @Prop({ type: String, default: '' }) currentId!: string;
  @Prop({ type: String, default: '' }) afterId!: string;
  @Prop({ type: Boolean, default: false }) useSort!: boolean;

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get size(): string {
    return flowHelper.readablizeBytes(this.file.size, 0)
  }

  download(file: any) {
    if (file.blob || file.file) {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(file.blob || file.file, file.name);
      } else {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(file.blob || file.file);
        link.download = `${file.name}`;
        link.click();
      }
    } else {
      let link = document.createElement('a');
      link.href = file.downloadUrl;
      link.target = "_blank";
      link.download = `${file.name}`;
      link.click();
    }
  }

  orderUp() {
    if (this.beforeId != '' && this.currentId != '') {
      if ((window as any).flowFileSwapStart) {
        (window as any).flowFileSwapStart();
      }

      api.file.swapFileSort({
        sourceId: this.currentId,
        targetId: this.beforeId
      }).then((res) => {
        if ((window as any).flowFileSwapCompleted) {
          (window as any).flowFileSwapCompleted(res);
        }
      }).catch((err) => {
        if ((window as any).flowFileSwapError) {
          (window as any).flowFileSwapError(err);
        }
      })
    }    
  }

  orderDown() {
    if (this.afterId != '' && this.currentId != '') {
      if ((window as any).flowFileSwapStart) {
        (window as any).flowFileSwapStart();
      }

      api.file.swapFileSort({
        sourceId: this.currentId,
        targetId: this.afterId
      }).then((res) => {
        if ((window as any).flowFileSwapCompleted) {
          (window as any).flowFileSwapCompleted(res);
        }
      }).catch((err) => {
        if ((window as any).flowFileSwapError) {
          (window as any).flowFileSwapError(err);
        }
      })
    }    
  }
}
